import { assert, isArray } from '../../../utils'

import { type Certificate, ConnectwareError, ConnectwareErrorType, selectCertificates } from '../../../domain'

import { Usecase } from '../Usecase'

export abstract class CertificatesUsecase extends Usecase {
    protected updateCertificates (remapper: (certs: readonly Certificate[]) => readonly Certificate[]): void {
        const certificates = selectCertificates(this.getState())
        assert(isArray(certificates), new ConnectwareError(ConnectwareErrorType.STATE, 'Application state is unexpected. Update not possible'))
        this.setState({ certificates: remapper(certificates) })
    }
}
